import PropTypes from "prop-types"
import { useEffect } from "react"

import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"
import useKlarnaOSM from "helpers/use-klarna-osm"

const Klarna = ({ price }) => {
  const klarnaOSMLoaded = useKlarnaOSM()

  useEffect(() => {
    if (!klarnaOSMLoaded) return

    if (window.Klarna?.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh()
    }
  }, [price, klarnaOSMLoaded])

  if (!enableKlarnaCheckout() || price <= 0) {
    return null
  }

  const locale = `en-${sl.config.site_country_for_analytics}`

  return (
    <>
      {/* <KlarnaContainer lessThan="tablet">
        <klarna-placement
          data-key="credit-promotion-badge"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </KlarnaContainer> */}
      {/* <KlarnaContainer greaterThanOrEqual="tablet"> */}
      <div className="h-20 w-fit overflow-hidden">
        <klarna-placement
          data-key="credit-promotion-auto-size"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </div>
      {/* </KlarnaContainer> */}
    </>
  )
}

Klarna.propTypes = {
  price: PropTypes.number,
}

export default Klarna
